<template lang="html">
  <li @click="toServiceDetail(service.spuId, index)">
    <a
      :href="`/v/product/${service.spuId}?refresh=no&hserecomkey=${
        this.$route.query.hserecomkey || ''
      }`"
      class="btn-bottom"
    >
      <img :src="service.cmmdtyImage | avatar(270, 162)" />
      <div class="info">
        <p class="name">{{ service.spuName }}</p>
        <p class="txt">
          <span v-if="service.saleNum > 0"
            >历史服务{{ service.saleNum }}人</span
          >
          <span v-if="service.commentScale > 0"
            >{{ service.commentScale | percentNum }}好评</span
          >
          <i v-else>&nbsp;</i>
        </p>
        <div class="price" v-html="price"></div>
      </div>
    </a>
  </li>
</template>

<script>
export default {
  props: {
    service: {
      type: Object,
      default() {
        return {}
      }
    },
    index: {
      type: Number,
      default: null
    }
  },
  data() {
    return {}
  },
  methods: {
    toServiceDetail(spuId, i) {
      const index = i + 1
      this.$$tracker('140101', '20000', '21127', index, spuId)
    }
  },
  computed: {
    price() {
      if (
        this.service.maxPrice === this.service.minPrice ||
        this.service.maxPrice === '' ||
        this.service.minPrice === 0
      ) {
        return `<span>&yen;</span>${this.service.minPrice / 100}`
      } else {
        return `<span>&yen;</span>${
          this.service.minPrice / 100
        }~<span>&yen;</span>${this.service.maxPrice / 100}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
li {
  display: block;
  // margin-top: rem(20px);
  padding: rem(30px) rem(20px);
  // border-bottom: rem(1px) solid #EBEBEB;
  background: #ffffff;
  @include border(bottom, #e5e5e5);
  a {
    display: flex;
    img {
      display: block;
      width: rem(250px);
      height: rem(150px);
    }
    .info {
      flex: 1;
      // padding: 0 rem(20px);
      margin-left: rem(20px);
      overflow: hidden;
      .name {
        max-height: rem(46px);
        color: #121212;
        font-size: rem(32px);
        line-height: rem(46px);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .txt {
        margin-bottom: rem(24px);
        color: #666666;
        font-size: rem(24px);
        line-height: rem(36px);

        > span {
          &::after {
            content: '';
            display: inline-block;
            width: 1px;
            height: rem(24px);
            margin: 0 rem(10px);
            vertical-align: text-bottom;
            border-right: 1px solid #666;
          }

          &:last-of-type {
            &::after {
              display: none;
            }
          }
        }
      }
      .price {
        margin-top: rem(4px);
        width: 100%;
        color: #ff397e;
        font-size: rem(36px);
        span {
          margin-right: rem(4px);
          font-size: rem(28px);
        }
      }
    }
  }
}
</style>
